import {combineReducers, configureStore} from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // Defaults to localStorage
import counterReducer from '@/slices/counterSlice';
import userSlice from "@/slices/userSlice";

// Persist Config
const persistConfig = {
    key: 'root', // Key for the root-level store
    storage,     // Storage mechanism (localStorage here)
};

// Combine Reducers and Add Persistence
// Combine reducers into a single rootReducer
const rootReducer = combineReducers({
    counter: counterReducer,
    user: userSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false, // Required for redux-persist
        }),
});

// Create a Persistor
export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
